import { Input as AntdInput }         from 'antd';
import React                          from 'react';
import { injectIntl }                 from 'react-intl';
import type { WrappedComponentProps } from 'react-intl';

interface IntlInputProps extends WrappedComponentProps {
  forwardedRef?: React.Ref<any>;
  placeholder?: any;
}

class IntlInput extends React.Component<IntlInputProps> {
  public static Password = AntdInput.Password;
  public static TextArea = AntdInput.TextArea;

  public render() {
    const { intl, placeholder, forwardedRef, ...restProps } = this.props;

    let translatedPlaceholder = undefined;
    if (placeholder) {
      translatedPlaceholder = intl.formatMessage({
        id: placeholder || ' ',
      });
    }

    return <AntdInput
        {...restProps}
        ref={forwardedRef}
        placeholder={translatedPlaceholder}
        autoComplete="off"
    />;
  }
}

const InjectedInput = injectIntl(IntlInput, { forwardRef: true });

interface InputType extends React.ForwardRefExoticComponent<any> {
  Password: React.FC<any>;
  TextArea: React.FC<any>;
}

const FinalInput = InjectedInput as unknown as InputType;

FinalInput.Password = AntdInput.Password;
FinalInput.TextArea = AntdInput.TextArea;

export default FinalInput;